// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./ShopeasyUiKit.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./Media.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.pointer-events-none {
  pointer-events: none;
}
.visible {
  visibility: visible;
}
.collapse {
  visibility: collapse;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.bottom-5 {
  bottom: 1.25rem;
}
.left-0 {
  left: 0px;
}
.left-1\\/2 {
  left: 50%;
}
.left-3 {
  left: 0.75rem;
}
.right-2 {
  right: 0.5rem;
}
.right-3 {
  right: 0.75rem;
}
.top-0 {
  top: 0px;
}
.top-1\\/2 {
  top: 50%;
}
.top-full {
  top: 100%;
}
.z-10 {
  z-index: 10;
}
.z-50 {
  z-index: 50;
}
.\\!m-4 {
  margin: 1rem !important;
}
.m-0 {
  margin: 0px;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-3 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-0\\.5 {
  margin-top: 0.125rem;
  margin-bottom: 0.125rem;
}
.my-1\\.5 {
  margin-top: 0.375rem;
  margin-bottom: 0.375rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-0\\.5 {
  margin-bottom: 0.125rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-2\\.5 {
  margin-bottom: 0.625rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.me-2 {
  margin-inline-end: 0.5rem;
}
.ml-0\\.5 {
  margin-left: 0.125rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.ml-auto {
  margin-left: auto;
}
.mr-1\\.5 {
  margin-right: 0.375rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mt-0 {
  margin-top: 0px;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-1\\.5 {
  margin-top: 0.375rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.\\!h-6 {
  height: 1.5rem !important;
}
.h-10 {
  height: 2.5rem;
}
.h-2 {
  height: 0.5rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-3 {
  height: 0.75rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-4 {
  height: 1rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-7 {
  height: 1.75rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[15px\\] {
  height: 15px;
}
.h-\\[17px\\] {
  height: 17px;
}
.h-\\[18px\\] {
  height: 18px;
}
.h-\\[36px\\] {
  height: 36px;
}
.h-\\[40px\\] {
  height: 40px;
}
.h-\\[450px\\] {
  height: 450px;
}
.h-\\[50px\\] {
  height: 50px;
}
.h-\\[55px\\] {
  height: 55px;
}
.h-\\[600px\\] {
  height: 600px;
}
.h-auto {
  height: auto;
}
.h-full {
  height: 100%;
}
.max-h-48 {
  max-height: 12rem;
}
.max-h-\\[200px\\] {
  max-height: 200px;
}
.max-h-\\[300px\\] {
  max-height: 300px;
}
.max-h-\\[45px\\] {
  max-height: 45px;
}
.max-h-\\[calc\\(100vh-130px\\)\\] {
  max-height: calc(100vh - 130px);
}
.max-h-full {
  max-height: 100%;
}
.min-h-\\[20px\\] {
  min-height: 20px;
}
.min-h-\\[24px\\] {
  min-height: 24px;
}
.min-h-\\[380px\\] {
  min-height: 380px;
}
.min-h-\\[40px\\] {
  min-height: 40px;
}
.min-h-\\[42px\\] {
  min-height: 42px;
}
.min-h-\\[45px\\] {
  min-height: 45px;
}
.min-h-\\[50px\\] {
  min-height: 50px;
}
.min-h-\\[52px\\] {
  min-height: 52px;
}
.min-h-\\[80px\\] {
  min-height: 80px;
}
.min-h-\\[calc\\(100vh-200px\\)\\] {
  min-height: calc(100vh - 200px);
}
.min-h-full {
  min-height: 100%;
}
.w-10 {
  width: 2.5rem;
}
.w-16 {
  width: 4rem;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-2\\/5 {
  width: 40%;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-3\\/5 {
  width: 60%;
}
.w-4 {
  width: 1rem;
}
.w-4\\/5 {
  width: 80%;
}
.w-48 {
  width: 12rem;
}
.w-5 {
  width: 1.25rem;
}
.w-6 {
  width: 1.5rem;
}
.w-7 {
  width: 1.75rem;
}
.w-8 {
  width: 2rem;
}
.w-9 {
  width: 2.25rem;
}
.w-\\[15px\\] {
  width: 15px;
}
.w-\\[17px\\] {
  width: 17px;
}
.w-\\[18px\\] {
  width: 18px;
}
.w-\\[1px\\] {
  width: 1px;
}
.w-\\[20\\%\\] {
  width: 20%;
}
.w-\\[200px\\] {
  width: 200px;
}
.w-\\[4\\%\\] {
  width: 4%;
}
.w-\\[40px\\] {
  width: 40px;
}
.w-\\[50px\\] {
  width: 50px;
}
.w-\\[6\\%\\] {
  width: 6%;
}
.w-auto {
  width: auto;
}
.w-fit {
  width: fit-content;
}
.w-full {
  width: 100%;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-\\[120px\\] {
  min-width: 120px;
}
.min-w-\\[190px\\] {
  min-width: 190px;
}
.min-w-\\[20px\\] {
  min-width: 20px;
}
.min-w-\\[32px\\] {
  min-width: 32px;
}
.min-w-\\[40px\\] {
  min-width: 40px;
}
.min-w-\\[45px\\] {
  min-width: 45px;
}
.min-w-\\[50px\\] {
  min-width: 50px;
}
.min-w-\\[80px\\] {
  min-width: 80px;
}
.min-w-\\[90px\\] {
  min-width: 90px;
}
.min-w-\\[95\\%\\] {
  min-width: 95%;
}
.min-w-full {
  min-width: 100%;
}
.max-w-\\[130px\\] {
  max-width: 130px;
}
.max-w-\\[20px\\] {
  max-width: 20px;
}
.max-w-\\[220px\\] {
  max-width: 220px;
}
.max-w-\\[40px\\] {
  max-width: 40px;
}
.max-w-\\[45px\\] {
  max-width: 45px;
}
.max-w-\\[80px\\] {
  max-width: 80px;
}
.max-w-\\[95\\%\\] {
  max-width: 95%;
}
.max-w-full {
  max-width: 100%;
}
.max-w-none {
  max-width: none;
}
.flex-1 {
  flex: 1 1;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink-0 {
  flex-shrink: 0;
}
.table-fixed {
  table-layout: fixed;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.\\!cursor-default {
  cursor: default !important;
}
.cursor-grab {
  cursor: grab;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.resize-none {
  resize: none;
}
.resize-y {
  resize: vertical;
}
.resize-x {
  resize: horizontal;
}
.resize {
  resize: both;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.place-items-center {
  place-items: center;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-0 {
  gap: 0px;
}
.gap-0\\.5 {
  gap: 0.125rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-x-4 {
  column-gap: 1rem;
}
.gap-x-6 {
  column-gap: 1.5rem;
}
.gap-y-4 {
  row-gap: 1rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.overflow-y-hidden {
  overflow-y: hidden;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-ellipsis {
  text-overflow: ellipsis;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.\\!rounded-xl {
  border-radius: 0.75rem !important;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-\\[4px\\] {
  border-radius: 4px;
}
.rounded-\\[6px\\] {
  border-radius: 6px;
}
.rounded-\\[var\\(--radius-sm\\)\\] {
  border-radius: var(--radius-sm);
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.\\!border {
  border-width: 1px !important;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-\\[2px\\] {
  border-width: 2px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-l {
  border-left-width: 1px;
}
.border-r {
  border-right-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-none {
  border-style: none;
}
.\\!border-\\[var\\(--border-color\\)\\] {
  border-color: var(--border-color) !important;
}
.border-\\[var\\(--border-color\\)\\] {
  border-color: var(--border-color);
}
.border-\\[var\\(--color-danger\\)\\] {
  border-color: var(--color-danger);
}
.border-\\[var\\(--color-info\\)\\] {
  border-color: var(--color-info);
}
.border-\\[var\\(--color-success\\)\\] {
  border-color: var(--color-success);
}
.border-\\[var\\(--color-warning\\)\\] {
  border-color: var(--color-warning);
}
.border-amber-200 {
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.border-blue-200 {
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}
.border-current {
  border-color: currentColor;
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-transparent {
  border-color: transparent;
}
.border-zinc-200 {
  --tw-border-opacity: 1;
  border-color: rgb(228 228 231 / var(--tw-border-opacity, 1));
}
.border-zinc-300 {
  --tw-border-opacity: 1;
  border-color: rgb(212 212 216 / var(--tw-border-opacity, 1));
}
.border-zinc-700\\/60 {
  border-color: rgb(63 63 70 / 0.6);
}
.border-t-transparent {
  border-top-color: transparent;
}
.\\!bg-\\[var\\(--secondary-bg-color\\)\\] {
  background-color: var(--secondary-bg-color) !important;
}
.bg-\\[\\#F4F4F5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 245 / var(--tw-bg-opacity, 1));
}
.bg-\\[var\\(--border-color\\)\\] {
  background-color: var(--border-color);
}
.bg-\\[var\\(--btn-bg-primary\\)\\] {
  background-color: var(--btn-bg-primary);
}
.bg-\\[var\\(--color-danger\\)\\] {
  background-color: var(--color-danger);
}
.bg-\\[var\\(--color-danger-bg\\)\\] {
  background-color: var(--color-danger-bg);
}
.bg-\\[var\\(--color-info-bg\\)\\] {
  background-color: var(--color-info-bg);
}
.bg-\\[var\\(--color-success\\)\\] {
  background-color: var(--color-success);
}
.bg-\\[var\\(--color-success-bg\\)\\] {
  background-color: var(--color-success-bg);
}
.bg-\\[var\\(--color-warning-bg\\)\\] {
  background-color: var(--color-warning-bg);
}
.bg-\\[var\\(--focus-tab-color\\)\\] {
  background-color: var(--focus-tab-color);
}
.bg-\\[var\\(--secondary-bg-color\\)\\] {
  background-color: var(--secondary-bg-color);
}
.bg-amber-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-500\\/20 {
  background-color: rgb(59 130 246 / 0.2);
}
.bg-emerald-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-gray-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
.bg-green-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-zinc-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 245 / var(--tw-bg-opacity, 1));
}
.bg-zinc-800\\/60 {
  background-color: rgb(39 39 42 / 0.6);
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.\\!p-0\\.5 {
  padding: 0.125rem !important;
}
.\\!p-1 {
  padding: 0.25rem !important;
}
.\\!p-1\\.5 {
  padding: 0.375rem !important;
}
.\\!p-5 {
  padding: 1.25rem !important;
}
.p-0 {
  padding: 0px;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.\\!px-0 {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.\\!px-2 {
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}
.\\!py-0 {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5 {
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-24 {
  padding-top: 6rem;
  padding-bottom: 6rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.\\!pl-9 {
  padding-left: 2.25rem !important;
}
.\\!pr-9 {
  padding-right: 2.25rem !important;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-\\[55px\\] {
  padding-bottom: 55px;
}
.pb-\\[64px\\] {
  padding-bottom: 64px;
}
.pe-3 {
  padding-inline-end: 0.75rem;
}
.pl-1 {
  padding-left: 0.25rem;
}
.pl-3 {
  padding-left: 0.75rem;
}
.pl-9 {
  padding-left: 2.25rem;
}
.pl-\\[9px\\] {
  padding-left: 9px;
}
.pr-16 {
  padding-right: 4rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pr-9 {
  padding-right: 2.25rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.font-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.\\!text-\\[12px\\] {
  font-size: 12px !important;
}
.\\!text-\\[13px\\] {
  font-size: 13px !important;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl {
  font-size: 3rem;
  line-height: 1;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[12px\\] {
  font-size: 12px;
}
.text-\\[13px\\] {
  font-size: 13px;
}
.text-\\[72px\\] {
  font-size: 72px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-extrabold {
  font-weight: 800;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.capitalize {
  text-transform: capitalize;
}
.italic {
  font-style: italic;
}
.leading-3 {
  line-height: .75rem;
}
.leading-7 {
  line-height: 1.75rem;
}
.leading-none {
  line-height: 1;
}
.leading-relaxed {
  line-height: 1.625;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.tracking-wider {
  letter-spacing: 0.05em;
}
.text-\\[\\#0c2639\\] {
  --tw-text-opacity: 1;
  color: rgb(12 38 57 / var(--tw-text-opacity, 1));
}
.text-\\[\\#3b82f6\\] {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.text-\\[var\\(--btn-bg-primary\\)\\] {
  color: var(--btn-bg-primary);
}
.text-\\[var\\(--color-danger\\)\\] {
  color: var(--color-danger);
}
.text-\\[var\\(--color-info\\)\\] {
  color: var(--color-info);
}
.text-\\[var\\(--color-success\\)\\] {
  color: var(--color-success);
}
.text-\\[var\\(--color-warning\\)\\] {
  color: var(--color-warning);
}
.text-\\[var\\(--primary-text-color\\)\\] {
  color: var(--primary-text-color);
}
.text-\\[var\\(--primary-text-color\\2c \\#202223\\)\\] {
  color: var(--primary-text-color,#202223);
}
.text-\\[var\\(--table-text-color\\)\\] {
  color: var(--table-text-color);
}
.text-\\[var\\(--table-text-color\\2c \\#6b7280\\)\\] {
  color: var(--table-text-color,#6b7280);
}
.text-amber-600 {
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-current {
  color: currentColor;
}
.text-emerald-300 {
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity, 1));
}
.text-emerald-800 {
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity, 1));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-green-600 {
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-indigo-600 {
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-zinc-400 {
  --tw-text-opacity: 1;
  color: rgb(161 161 170 / var(--tw-text-opacity, 1));
}
.text-zinc-500 {
  --tw-text-opacity: 1;
  color: rgb(113 113 122 / var(--tw-text-opacity, 1));
}
.text-zinc-800 {
  --tw-text-opacity: 1;
  color: rgb(39 39 42 / var(--tw-text-opacity, 1));
}
.underline {
  text-decoration-line: underline;
}
.underline-offset-4 {
  text-underline-offset: 4px;
}
.placeholder-gray-400::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(156 163 175 / var(--tw-placeholder-opacity, 1));
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-60 {
  opacity: 0.6;
}
.opacity-70 {
  opacity: 0.7;
}
.opacity-80 {
  opacity: 0.8;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[-4px_0_6px_-2px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.06\\)\\] {
  --tw-shadow: -4px 0 6px -2px rgba(0,0,0,0.06);
  --tw-shadow-colored: -4px 0 6px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[4px_0_6px_-2px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.06\\)\\] {
  --tw-shadow: 4px 0 6px -2px rgba(0,0,0,0.06);
  --tw-shadow-colored: 4px 0 6px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.\\!shadow-\\[var\\(--shadow-popover\\)\\] {
  --tw-shadow-color: var(--shadow-popover) !important;
  --tw-shadow: var(--tw-shadow-colored) !important;
}
.shadow-\\[var\\(--shadow-card\\)\\] {
  --tw-shadow-color: var(--shadow-card);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline {
  outline-style: solid;
}
.ring-0 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}


* {
  font-family: 'Inter', sans-serif !important;
}

.ql-font-serif {
  font-family: 'Instrument Serif', serif !important;
}

.ql-font-monospace {
  font-family: 'Space Mono', monospace !important;
}

.loader {
  width: 70px;
  padding: 5px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: var(--btn-bg-primary);
  --_m: conic-gradient(#0000 10%, #000), linear-gradient(#000 0 0) content-box;
  mask: var(--_m);
  -webkit-mask-composite: source-out;
  animation: l3 1s infinite linear;
}

@keyframes l3 {
  to {
    transform: rotate(1turn);
  }
}

.menu-dropdown {
  transition: all 0.5s;
}

.menu-dropdown .close {
  opacity: 0;
  visibility: hidden;
  height: 0;
  transition: all 0.5s;
  margin-left: 20px;
}

.bg {
  background-color: #74ebd5;
  background-image: linear-gradient(90deg, #74ebd5 0%, #9face6 100%);
}

.bg .form {
  box-shadow: 0 20px 45px 0 rgb(0, 0, 0, 0.2);
}

.menu-dropdown .open {
  /* opacity: 1;
  visibility: visible; */
  /* height: 100%; */
  transition: all 0.5s;
  margin-left: 20px;
  animation: menu 5s 1;
}

.ql-snow .ql-editor h1 {
  font-size: 40px !important;
}

.ql-snow .ql-editor h2 {
  font-size: 36px !important;
}

.ql-snow .ql-editor h3 {
  font-size: 32px !important;
}

.ql-snow .ql-editor h4 {
  font-size: 28px !important;
}

.ql-snow .ql-editor h5 {
  font-size: 24px !important;
}

.ql-snow .ql-editor h6 {
  font-size: 20px !important;
}

/* :root {
  --sidebar-bg-color: #28282b;
  --sidebar-bg-color-rgb: 40, 40, 43;
  --btn-bg-primary: #28282b;
  --btn-bg-primary-rgb: rgb(40, 40, 43);
  --bg-btn-hover: #000000;
  --bg-btn-hover-rgb: rgb(0, 0, 0);
  --primary-bg-color: #f6f6f7;
  --primary-bg-color-rgb: 246, 246, 247;
  --secondary-bg-color: #ffffff;
  --secondary-bg-color-rgb: rgb(255, 255, 255);
  --primary-text-color: #202223;
  --primary-text-color-rgb: rgb(32, 34, 35);
  --border-color: #e1e3e5;
  --border-color-rgb: 225, 227, 229;
  --focus-border-color: #8c9196;
  --focus-border-color-rgb: rgb(140, 145, 150);
  --focus-tab-color: #f1f2f3;
  --focus-tab-color-rgb: rgb(241, 242, 243);
  --table-text-color: #6b7280;
  --table-text-color-rgb: rgb(107, 114, 128);
  --tawk-header-background-color: var(--sidebar-bg-color);
  --tawk-header-background-color-rgb: var(var(--sidebar-bg-color-rgb));
} */

.dark-mode {
  --sidebar-bg-color: #111;
  --sidebar-bg-color-rgb: rgb(17, 17, 17);
  --primary-bg-color: #222;
  --primary-bg-color-rgb: rgb(34, 34, 34);
  --secondary-bg-color: #333333;
  --secondary-bg-color-rgb: rgb(51, 51, 51);
  --primary-text-color: #ccc;
  --primary-text-color-rgb: rgb(204, 204, 204);
  --border-color: #444;
  --border-color-rgb: rgb(68, 68, 68);
  --table-text-color: #a0a0a0;
  --table-text-color-rgb: rgb(160, 160, 160);
  --focus-border-color: #555;
  --focus-border-color-rgb: rgb(85, 85, 85);
  --focus-tab-color: #444;
  --focus-tab-color-rgb: rgb(68, 68, 68);
}

body {
  color: var(--primary-text-color);
}

.dark-mode .bg-white,
.dark-mode .bg-gray-50,
.dark-mode .bg-gray-100 {
  background-color: var(--secondary-bg-color);
}

.dark-mode .hover\\:bg-gray-100:hover {
  background-color: var(--focus-tab-color);
}

.primary-text-color {
  color: var(--primary-text-color);
}

.plan-popup .MuiBackdrop-root.MuiModal-backdrop {
  background-color: initial !important;
}

.primary-bg-color {
  background-color: var(--primary-bg-color) !important;
}

.secondary-bg-color,
.cTsUPQ {
  background-color: var(--secondary-bg-color) !important;
}

.MuiLinearProgress-root {
  background-color: var(--sidebar-bg-color) !important;
  height: 3px !important;
}

.MuiLinearProgress-bar {
  background-color: white !important;
  transition: transform 2s linear !important;
  width: 80% !important;
  right: 0 !important;
}

.text-btn {
  color: var(--btn-bg-primary);
}

.table-text {
  color: var(--table-text-color) !important;
}

.bg-btn {
  background-color: var(--btn-bg-primary);
  border: 1px solid var(--btn-bg-primary);
}

/* ==========================================================================
   SCROLLBAR STYLING (Consolidated in One Place)
   ========================================================================== */

/* Hide Scrollbar Buttons / Arrows Globally */
::-webkit-scrollbar-button {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

/* WebKit Scrollbar (Chrome, Safari, Edge) */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.25);
  border-radius: 6px;
  -webkit-transition: background-color 0.3s ease;
  transition: background-color 0.3s ease;
}

::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.45);
}

/* Standard Custom Scrollbar (Always Visible) */
.custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.25);
  border-radius: 6px;
  -webkit-transition: background-color 0.3s ease;
  transition: background-color 0.3s ease;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.45);
}

.dark-mode .custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.2);
}

.custom-scrollbar {
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.25) transparent;
}

.dark-mode .custom-scrollbar {
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
}

/* Sidebar Scrollbar - Visible ONLY on Sidebar Hover */
.sidebar-scrollbar::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.sidebar-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}

.sidebar-scrollbar::-webkit-scrollbar-thumb {
  background-color: transparent;
  border-radius: 6px;
  -webkit-transition: background-color 0.3s ease;
  transition: background-color 0.3s ease;
}

.sidebar-scrollbar:hover::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.25);
}

.sidebar-scrollbar:hover::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.45);
}

.dark-mode .sidebar-scrollbar::-webkit-scrollbar-thumb {
  background-color: transparent;
}

.dark-mode .sidebar-scrollbar:hover::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.2);
}

.dark-mode .sidebar-scrollbar:hover::-webkit-scrollbar-thumb:hover {
  background-color: rgba(255, 255, 255, 0.4);
}

.sidebar-scrollbar {
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
}

.sidebar-scrollbar:hover {
  scrollbar-color: rgba(0, 0, 0, 0.25) transparent;
}

.dark-mode .sidebar-scrollbar:hover {
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
}

.sidebar {
  transition: all 0.3s;
  min-width: 300px;
  max-width: 300px;
  display: flex;
  flex-direction: column;
  flex-grow: 0;
  flex-shrink: 1;
  min-height: 1px;
}

.sidebar button:focus,
.sidebar a:focus {
  outline: none;
}

.MuiBadge-badge {
  background-color: var(--sidebar-bg-color) !important;
  color: var(--primary-bg-color) !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  top: -1px !important;
  right: -2px !important;
}

.dark-mode .MuiBadge-badge {
  color: var(--table-text-color) !important;
}

.notification .MuiPaper-root.MuiPaper-elevation {
  border-radius: 4px 0 0 4px;
}

.my-tooltip-class.MuiTooltip-tooltip {
  background-color: var(--sidebar-bg-color) !important;
  padding: 8px 16px !important;
  color: white !important;
  margin-left: 20px !important;
  font-size: 13px !important;
  letter-spacing: 1px;
}

.my-tooltip-class .MuiTooltip-arrow::before {
  background: var(--sidebar-bg-color) !important;
}

.sidebar.close {
  width: 60px;
  min-width: 60px;
  max-width: 60px;
}

.close .sidebar {
  width: 60px;
  min-width: 60px;
  max-width: 60px;
}

.absolute-loader {
  width: 100%;
  height: 100%;
  /* position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%); */
}


.tooltip-perent {
  position: relative;
  display: block;
  transition: all 0.3s;
}

.tooltip {
  position: absolute;
  left: -70%;
  top: 130%;
  opacity: 0;
  transition: all 0.3s;
}

.popup-content .MuiPaper-root.MuiPopover-paper {
  position: absolute !important;
  z-index: 20 !important;
  left: 50% !important;
  top: 50% !important;
  transform: translate(-50%, -50%) !important;
  border-radius: 4px !important;
}

.tooltip-arrow {
  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
  background-color: var(--primary-text-color);
  width: 10px;
  height: 6px;
  position: absolute;
  top: -2px;
  left: 50%;
  transform: translate(-50%, -50%);
}

.tooltip-perent:hover .tooltip {
  opacity: 1;
}

.nb-spinner,
.nb-spinner-small {
  display: inline-block;
  width: 30px;
  height: 30px;
  border: 4px solid var(--primary-text-color);
  border-top: 4px solid var(--border-color);
  border-radius: 50%;
  animation: spin 2s linear infinite;
}

.nb-spinner-small {
  width: 20px;
  height: 20px;
  border: 2px solid var(--primary-text-color);
  border-top: 2px solid var(--border-color);
}

.data-loader {
  display: inline-block;
  width: 50px;
  height: 50px;
  border: 4px solid var(--border-color);
  border-top: 4px solid var(--primary-text-color);
  border-radius: 50%;
  animation: spin 2s linear infinite;
}

.custom-toast {
  font-size: 10px !important;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.pagination {
  background-color: var(--secondary-bg-color);
  border-color: var(--border-color) !important;
  color: var(--table-text-color);
}

.pagination .MuiButtonBase-root.MuiPaginationItem-root.Mui-selected {
  background-color: var(--primary-bg-color);
  border-radius: 100%;
}

.pagination .MuiButtonBase-root.MuiPaginationItem-root.MuiPaginationItem-text {
  color: var(--table-text-color);
}

.pagination .MuiButtonBase-root.MuiPaginationItem-root.MuiPaginationItem-text:hover {
  background-color: var(--primary-bg-color) !important;
}

.pagination .selected {
  border: none !important;
}

.active {
  color: white !important;
}

.detail-container {
  padding: 0 !important;
}

.text-primary {
  color: var(--primary-text-color) !important;
}

.text-link {
  /* color: var(--btn-bg-primary) !important; */
  transition: all 0.3s;
}

.text-link:hover {
  /* color: var(--btn-bg-primary) !important; */
}

.page_builder_container:hover {
  border: 2px solid var(--btn-bg-primary);
}

.ql-toolbar.ql-snow+.ql-container.ql-snow {
  border-radius: 0px 0px 4px 4px !important;
}

.ql-toolbar.ql-snow {
  border-radius: 4px 4px 0px 0px !important;
}

.bg-primary {
  background-color: var(--sidebar-bg-color) !important;
}

.btn {
  background-color: var(--btn-bg-primary) !important;
  border-radius: 4px !important;
  padding: 8px 20px !important;
  border: 1px solid var(--btn-bg-primary);
}

.secondary-btn {
  border: 1px solid var(--btn-bg-primary);
  background-color: white;
  color: var(--btn-bg-primary);
  transition: all 0.3s;
  border-radius: 4px !important;
  padding: 8px 20px !important;
}

.ql-editor {
  min-height: 150px !important;
  max-height: auto;
}

.ql-editor.elementor-editor {
  min-height: unset !important;
}

.main-border-color {
  border-color: var(--border-color) !important;
}

.focus-border-color {
  border-color: var(--focus-border-color) !important;
}

.focus-tab {
  background-color: var(--focus-tab-color) !important;
  color: var(--primary-text-color) !important;
}

.tab {
  padding: 8px 15px;
  background-color: transparent;
  font-size: 12px;
  line-height: 13px;
  border-radius: 4px;
  text-transform: capitalize;
  font-weight: 500;
  color: var(--table-text-color);
  transition: all 0.2s;
  display: inline-block;
}

.file-tag-hover .tab {
  padding: 8px 10px !important;
  border-radius: 30px !important;
}

.tab:hover {
  color: var(--primary-text-color);
}

.border-secondary {
  border: 1px solid var(--btn-bg-primary);
}

.react-datepicker__header {
  background-color: var(--primary-bg-color) !important;
  border-bottom: 1px solid var(--border-color) !important;
}

.react-datepicker__current-month,
.react-datepicker-time__header,
.react-datepicker-year-header,
.react-datepicker__day-name,
.react-datepicker__day,
.react-datepicker__time-name {
  color: var(--primary-text-color) !important;
}

.react-datepicker__month {
  margin: 0 !important;
  padding: 0.4rem !important;
  background-color: var(--secondary-bg-color) !important;
}

.react-datepicker {
  background-color: var(--secondary-bg-color) !important;
  border-color: var(--border-color) !important;
  box-shadow: var(--shadow-popover);
}

.react-datepicker__month-container {
  background-color: var(--secondary-bg-color) !important;
}

.react-datepicker-wrapper {
  width: 100% !important;
}

.react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::before,
.react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::after {
  border-bottom-color: var(--border-color) !important;
}

.react-datepicker__day.react-datepicker__day--disabled {
  opacity: 40% !important;
  cursor: not-allowed;
}

/* Keyboard focus when calendar opens should not force an ugly background box */
.react-datepicker__day--keyboard-selected {
  background-color: transparent !important;
  color: var(--primary-text-color) !important;
}

/* Subtle indicator for today's date */
.react-datepicker__day--today {
  font-weight: 600 !important;
  border: 1px solid var(--border-color) !important;
  border-radius: 4px !important;
}

/* Selected dates and range endpoints — using theme variables */
.react-datepicker__day--selected,
.react-datepicker__day--range-start,
.react-datepicker__day--range-end,
.react-datepicker__day--keyboard-selected.react-datepicker__day--selected {
  background-color: var(--primary-text-color) !important;
  color: var(--secondary-bg-color) !important;
  border-radius: 4px !important;
  font-weight: 600 !important;
  border: none !important;
}

/* In-between range dates — using theme focus tab color */
.react-datepicker__day--in-range,
.react-datepicker__day--in-selecting-range {
  background-color: var(--focus-tab-color) !important;
  color: var(--primary-text-color) !important;
  border-radius: 0 !important;
}

.dark-mode .react-datepicker__day--in-range,
.dark-mode .react-datepicker__day--in-selecting-range {
  background-color: var(--focus-tab-color) !important;
  color: var(--primary-text-color) !important;
  border-radius: 0 !important;
}

.react-datepicker__day:hover {
  background-color: var(--focus-tab-color) !important;
  color: var(--primary-text-color) !important;
  border-radius: 4px !important;
}

.dark-mode .react-datepicker__day:hover {
  background-color: var(--focus-tab-color) !important;
  color: var(--primary-text-color) !important;
  border-radius: 4px !important;
}

.react-datepicker-popper {
  z-index: 35 !important;
}

/* DatePicker Clear (X) button — UI theme native colors */
.react-datepicker__close-icon {
  padding: 0 4px 0 0 !important;
}

.react-datepicker__close-icon::after {
  background-color: var(--table-text-color) !important;
  color: var(--secondary-bg-color) !important;
  border-radius: 50% !important;
  font-size: 11px !important;
  width: 15px !important;
  height: 15px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  line-height: 1 !important;
  padding: 0 !important;
  transition: all 0.2s ease !important;
}

.react-datepicker__close-icon:hover::after {
  background-color: var(--primary-text-color) !important;
  color: var(--secondary-bg-color) !important;
}

/* Fix DatePicker input text visibility inside filter popover */
.filter .react-datepicker__input-container input,
.filter input.react-datepicker-ignore-onclickoutside {
  background-color: #ffffff !important;
  color: #111111 !important;
  padding: 6px 10px !important;
}

.dark-mode .filter .react-datepicker__input-container input,
.dark-mode .filter input.react-datepicker-ignore-onclickoutside {
  background-color: #2a2a2a !important;
  color: #e0e0e0 !important;
  border-color: #555 !important;
}

.secondary-btn:hover {
  background-color: var(--btn-bg-primary);
  color: white;
}

.btn:hover {
  background-color: var(--bg-btn-hover) !important;
}

.border-primary {
  border-color: var(--sidebar-bg-color);
}

.border-primary-color {
  border-color: var(--btn-bg-primary) !important;
}

.info-link {
  color: #7f7f7f;
  transition: all 0.3s;
}

.info-link:hover {
  color: #616161;
}

.fwGovb {
  font-weight: 700 !important;
  text-transform: uppercase;
}

.rdt_TableCell {
  color: var(--table-text-color);
  font-weight: 400;
  font-size: 13px;
  letter-spacing: 0.5px;
}

.gVZIpW,
.dMnwYK:nth-of-type(n) {
  height: 55px !important;
}

.variant-table .gVZIpW,
.variant-table .dMnwYK:nth-of-type(n),
.delete-logs .gVZIpW,
.delete-logs .dMnwYK:nth-of-type(n) {
  min-height: 55px !important;
  height: auto !important;
  padding: 5px 0 !important;
}

.sticky-column {
  position: sticky !important;
  left: 0 !important;
  background-color: inherit !important;
  z-index: 5 !important;
}

.gVZIpW:not(:last-of-type) {
  border-bottom: 1px solid rgba(var(--border-color-rgb), 70%) !important;
  /* border-top: 0.5px solid rgba(var(--border-color-rgb),70%) !important; */
}

.dark-mode .gVZIpW:not(:last-of-type) {
  border-bottom: 1px solid var(--border-color) !important;
}

.dashboard .gVZIpW {
  height: 45px !important;
  color: var(--table-text-color) !important;
  font-size: 12px !important;
  background-color: var(--secondary-bg-color) !important;
}

.gVZIpW {
  background-color: var(--secondary-bg-color) !important;
}

.cTsUPQ {
  color: var(--table-text-color) !important;
  min-height: 280px !important;
}

.rdt_TableRow {
  cursor: pointer;
}

/* .gVZIpW {
  border-top: 0.5px solid var(--border-color) !important;
} */

.gVZIpW:hover {
  background-color: rgba(var(--primary-bg-color-rgb), 70%) !important;
  /* border-top: 0.5px solid var(--border-color) !important; */
  border-color: rgba(var(--border-color-rgb), 70%);
  outline: none !important;
}

.dark-mode .gVZIpW:hover {
  background-color: var(--btn-bg-primary) !important;
}

.drag-btn {
  opacity: 0;
}

.gVZIpW:hover .drag-btn {
  opacity: 1;
}

.cRzJdb,
.sc-kpDqfm {
  margin-left: 10px !important;
  font-size: 8px;
}

.dIyxTF,
.jDsDCL {
  min-width: 30px !important;
  flex: 0 0 !important;
  justify-content: end !important;
}

/* .MuiAutocomplete-hasPopupIcon.css-1h51icj-MuiAutocomplete-root .MuiOutlinedInput-root,
.MuiAutocomplete-hasClearIcon.css-1h51icj-MuiAutocomplete-root .MuiOutlinedInput-root {
  padding: 5px !important;
}

.MuiAutocomplete-hasPopupIcon.css-1h51icj-MuiAutocomplete-root .MuiOutlinedInput-root,
.MuiAutocomplete-hasClearIcon.css-1h51icj-MuiAutocomplete-root .MuiOutlinedInput-root {
  padding: 2px 4px !important;
} */

.css-nxo287-MuiInputBase-input-MuiOutlinedInput-input {
  padding: 10.5px 14px !important;
}

.faq-autocomplete.css-1h51icj-MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input {
  color: var(--primary-text-color) !important;
}

.MuiInputBase-root.Mui-focused {
  border: none !important;
  outline: none !important;
}

.myDIV {
  background-color: black;
}

.apexcharts-reset-icon,
.apexcharts-pan-icon {
  display: none;
}

.apexcharts-toolbar {
  display: none !important;
}

.breadcrumb-divider {
  position: relative;
  margin-right: 18px;
  display: inline-block;
}

.breadcrumb-divider::after {
  content: '';
  width: 9px;
  height: 100%;
  border-top: 1px solid var(--border-color);
  transform: rotate(-70deg);
  position: absolute;
  right: -20px;
  top: 4px;
}

.card {
  position: relative;
  display: flex;
  width: 450px;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background: linear-gradient(rgba(255, 255, 255, 0.12) 0%, var(--secondary-bg-color) 100%);
  background-clip: border-box;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  box-shadow: 0px 0px 5px 0px rgb(161, 163, 164);
}

.card .card-body {
  padding: 1rem 1rem;
}

.card-body {
  flex: 1 1 auto;
  padding: 1.25rem;
}

p {
  font-size: 14px;
}

.cross {
  padding: 10px;
  color: #d6312d;
  cursor: pointer;
}

.continue:focus {
  outline: none;
}

.continue {
  border-radius: 4px;
  text-transform: capitalize;
  font-size: 13px;
  padding: 8px 19px;
  cursor: pointer;
  color: var(--primary-bg-color);
  background-color: #d50000;
}

.continue:hover {
  background-color: #d32f2f !important;
}

.cart-items .css-3bmhjh-MuiPaper-root-MuiPopover-paper {
  box-shadow:
    0px 5px 5px -3px rgba(0, 0, 0, 0.2),
    0px 8px 10px 1px rgba(0, 0, 0, 0.14),
    0px 3px 14px 2px rgba(0, 0, 0, 0.12);
}

.react-colorful,
.w-color-swatch.w-color-github.w-color-chrome {
  position: absolute !important;
  left: 0;
  display: block;
  top: 100%;
  z-index: 999999 !important;
}

.kubBPN:hover {
  background-color: transparent !important;
  color: black !important;
}

.kubBPN:focus {
  background-color: transparent !important;
}

@media (max-width: 767px) {

  .btn,
  .secondary-btn {
    border-radius: 4px !important;
    padding: 6px 10px !important;
    font-size: 12px !important;
  }

  .back-arrow {
    display: none;
  }

  .filter-btn {
    width: 35px;
    height: 35px;
  }

  /* input[type="text"],
  input[type="number"],
  input[type="Number"],
  input[type="email"],
  input[type="password"],
  input[type="date"],
  select,
  textarea {
    padding: 6px 12px !important;
    font-size: 14px !important;
    line-height: 20px !important;
  } */

  .sticky-table .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(3),
  .sticky-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(3),
  .customer-table .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(3),
  .customer-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(3),
  .category-table .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(2),
  .category-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(2),
  .add-variant-table table thead tr td:first-child,
  .add-variant-table table tbody tr td:first-child {
    position: relative !important;
  }

  .sticky-table .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:last-child,
  .sticky-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child,
  .product-table .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:last-child,
  .product-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child,
  .category-table .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:last-child,
  .category-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child,
  .blog-table .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:last-child,
  .blog-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child,
  .customer-table .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-last-child(2),
  .customer-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-last-child(2),
  .add-discount-table table thead tr td:last-child,
  .add-discount-table table tbody tr td:last-child {
    position: relative !important;
  }
}

.slick-next,
.slick-prev {
  /* background: black !important;
  opacity: 75%; */
  color: white !important;
  width: 30px !important;
  height: 30px !important;
  border-radius: 50%;
  z-index: 9 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.slick-next {
  right: -36px !important;
}

.slick-prev {
  left: -36px !important;
}

.main-slider .slick-prev {
  left: 36px !important;
}

.main-slider .slick-next {
  right: 36px !important;
}

.slick-prev:before,
.slick-next:before {
  content: '' !important;
}

.custom-prev-arrow,
.custom-next-arrow {
  /* Your custom styles for arrows */
  background-color: blue;
  color: white;
  border-radius: 50%;
  padding: 10px;
  cursor: pointer;
}

.css-5ryogn-MuiButtonBase-root-MuiSwitch-switchBase.Mui-checked.Mui-disabled {
  color: white !important;
}

input[type='radio'] {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 20px;
  height: 20px;
  border: 2px solid black;
  border-radius: 50%;
  outline: none;
  cursor: pointer;
  position: relative;
}

input[type='radio']:checked::before {
  content: '';
  display: block;
  width: 12px;
  height: 12px;
  background-color: black;
  border-radius: 50%;
  position: absolute;
  top: 2px;
  left: 2px;
}

.css-j204z7-MuiFormControlLabel-root {
  margin-right: 0 !important;
}

.css-j204z7-MuiFormControlLabel-root.Mui-disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.css-143ulsi-JoySnackbar-endDecorator button {
  transition:
    background-color 0.3s ease,
    transform 0.3s ease;
}

.css-143ulsi-JoySnackbar-endDecorator button:hover {
  background-color: rgba(0, 0, 0, 0.1);
  transform: scale(1.1);
}

.bold-date {
  font-weight: bold;
}

.order-table .cTsUPQ {
  min-height: 72px !important;
}

.dragLine {
  border: none !important;
}

@keyframes slideIn {
  0% {
    transform: translateY(-100%);
  }

  100% {
    transform: translateY(0);
  }
}

.animate-slideIn {
  animation: slideIn 0.5s ease-out forwards;
}

@keyframes bounceDelayed {

  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-5px);
  }
}

.typing-dot {
  animation: bounceDelayed 0.6s infinite ease-in-out;
}

.typing-dot:nth-child(2) {
  animation-delay: 0.2s;
}

.typing-dot:nth-child(3) {
  animation-delay: 0.4s;
}

.marquee-wrapper {
  width: 100%;
  overflow: hidden;
}

.marquee-text {
  display: flex;
  animation: marqueeLeftToRight 10s linear infinite;
}

.marquee-text p {
  white-space: nowrap;
  color: #222;
  font-size: 15px;
  padding: 5px;
}

@keyframes marqueeLeftToRight {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-50%);
  }
}

/* Base slider styles */
.custom-slider {
  -webkit-appearance: none;
  /* Removes default browser styling */
  width: 100%;
  height: 6px;
  background: #e5e5e5;
  /* Track background color */
  border-radius: 3px;
  outline: none;
  cursor: pointer;
}

.custom-slider::-webkit-slider-thumb {
  appearance: none;
  width: 20px;
  height: 20px;
  background: #000;
  border-radius: 50%;
  cursor: pointer;
  border: 2px solid #fff;
}

.custom-slider::-moz-range-thumb {
  width: 20px;
  height: 20px;
  background: #000;
  border-radius: 50%;
  cursor: pointer;
  border: 2px solid #fff;
}

.custom-slider::-ms-thumb {
  width: 20px;
  height: 20px;
  background: #000;
  border-radius: 50%;
  cursor: pointer;
  border: 2px solid #fff;
}

/* Change ReactQuill placeholder text color */
.ql-editor.ql-blank::before {
  color: #9ca3af !important;
  opacity: 1 !important;
  font-style: normal !important;
}


/* ✅ Ordered List */
.editor-area ol {
  list-style-type: decimal !important;
  padding-left: 1.5rem;
}

/* ✅ Unordered List */
.editor-area ul {
  list-style-type: disc !important;
  padding-left: 1.5rem;
}

/* ✅ Proper Heading Styling (FIXED selector) */
.editor-area h1 {
  font-size: 32px;
  font-weight: 700;
}

.editor-area h2 {
  font-size: 24px;
  font-weight: 700;
}

.editor-area h3 {
  font-size: 18.72px;
  font-weight: 600;
}

.editor-area h4 {
  font-size: 16px;
  font-weight: 600;
}

.editor-area h5 {
  font-size: 13.28px;
  font-weight: 500;
}

.editor-area h6 {
  font-size: 12px;
  font-weight: 500;
}

/* ✅ Paragraph spacing */
.editor-area p {
  margin-bottom: 16px;
}

/* ✅ Code view protection */
.editor-area pre {
  white-space: pre-wrap;
}

.editor-area hr {
  border: none;
  border-top: 1px solid #d1d5db;
  /* gray-300 */
  margin: 16px 0;
}

/* ✅ Universal Link Style (Editor + CodeView + Live Article) */
.editor-area a {
  color: #2563eb;
  /* Tailwind blue-600 */
  text-decoration: underline;
  cursor: pointer;
  font-weight: 500;
}

.editor-area a:hover {
  color: #1d4ed8;
  /* Tailwind blue-700 */
}

.tooltip-root:hover .tooltip-box {
  opacity: 1;
  transform: scale(1);
}

.input-datepicker {
  border-radius: 8px !important;
  box-shadow: none !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 20px !important;
  outline: none !important;
  padding: 8px 12px !important;
}

.input-datepicker:focus {
  outline: none !important;
  box-shadow: none !important;
}

/* ── Dark Mode Compatibility Overrides ── */
.dark-mode .text-indigo-600,
.dark-mode .text-indigo-500 {
  color: var(--secondary-text-color) !important;
}

.dark-mode .text-gray-900,
.dark-mode .text-gray-800 {
  color: var(--primary-text-color) !important;
}

.dark-mode .text-gray-700,
.dark-mode .text-gray-600 {
  color: #e5e7eb !important;
}

.dark-mode .text-gray-500 {
  color: #9ca3af !important;
}

.dark-mode .bg-gray-50,
.dark-mode .bg-gray-100 {
  background-color: #2e2e2e !important;
}

.dark-mode .bg-indigo-50 {
  background-color: var(--btn-bg-primary) !important;
  border-color: var(--secondary-text-color) !important;
}

.dark-mode .border-gray-200,
.dark-mode .border-gray-300 {
  border-color: #3a3a3a !important;
}

/* ── Form Toggle Switch ── */
.form-toggle-track {
  width: 44px;
  height: 24px;
  display: flex;
  align-items: center;
  border-radius: 9999px;
  padding: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease, border-color 0.3s ease;
  background-color: #d1d5db;
}

.form-toggle-track.active {
  background-color: #1a1a1a;
}

.form-toggle-thumb {
  background-color: #ffffff;
  width: 16px;
  height: 16px;
  border-radius: 9999px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
  transform: translateX(0);
  transition: transform 0.3s ease, background-color 0.3s ease;
}

.form-toggle-track.active .form-toggle-thumb {
  transform: translateX(20px);
}

/* ── Dark Mode Toggle Support ── */
.dark-mode .form-toggle-track {
  background-color: #3f3f46;
}

.dark-mode .form-toggle-track.active {
  background-color: #ffffff;
}

.dark-mode .form-toggle-thumb {
  background-color: #d4d4d8;
}

.dark-mode .form-toggle-track.active .form-toggle-thumb {
  background-color: #18181b;
}

.placeholder\\:text-\\[13px\\]::placeholder {
  font-size: 13px;
}

.placeholder\\:text-xs::placeholder {
  font-size: 0.75rem;
  line-height: 1rem;
}

.placeholder\\:font-normal::placeholder {
  font-weight: 400;
}

.placeholder\\:text-\\[var\\(--table-text-color\\)\\]::placeholder {
  color: var(--table-text-color);
}

.hover\\:border-\\[var\\(--focus-border-color\\)\\]:hover {
  border-color: var(--focus-border-color);
}

.hover\\:bg-\\[var\\(--bg-btn-hover\\)\\]:hover {
  background-color: var(--bg-btn-hover);
}

.hover\\:bg-\\[var\\(--focus-tab-color\\)\\]:hover {
  background-color: var(--focus-tab-color);
}

.hover\\:bg-\\[var\\(--focus-tab-color\\2c \\#f1f2f3\\)\\]:hover {
  background-color: var(--focus-tab-color,#f1f2f3);
}

.hover\\:bg-blue-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-50\\/20:hover {
  background-color: rgb(239 246 255 / 0.2);
}

.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-500\\/10:hover {
  background-color: rgb(107 114 128 / 0.1);
}

.hover\\:text-\\[var\\(--primary-text-color\\)\\]:hover {
  color: var(--primary-text-color);
}

.hover\\:text-gray-600:hover {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}

.hover\\:text-green-800:hover {
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-600:hover {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}

.hover\\:underline:hover {
  text-decoration-line: underline;
}

.hover\\:opacity-100:hover {
  opacity: 1;
}

.hover\\:opacity-70:hover {
  opacity: 0.7;
}

.hover\\:opacity-90:hover {
  opacity: 0.9;
}

.hover\\:shadow:hover {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.focus\\:border-\\[var\\(--color-danger\\)\\]:focus {
  border-color: var(--color-danger);
}

.focus\\:border-\\[var\\(--focus-border-color\\)\\]:focus {
  border-color: var(--focus-border-color);
}

.focus\\:bg-\\[var\\(--secondary-bg-color\\)\\]:focus {
  background-color: var(--secondary-bg-color);
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-0:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-transparent:focus {
  --tw-ring-color: transparent;
}

.focus\\:ring-offset-0:focus {
  --tw-ring-offset-width: 0px;
}

.focus-visible\\:outline-none:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.active\\:scale-95:active {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:scale-\\[0\\.98\\]:active {
  --tw-scale-x: 0.98;
  --tw-scale-y: 0.98;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:cursor-grabbing:active {
  cursor: grabbing;
}

.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}

.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}

.group[open] .group-open\\:rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:text-\\[var\\(--primary-text-color\\2c \\#202223\\)\\] {
  color: var(--primary-text-color,#202223);
}

.group:hover .group-hover\\:opacity-70 {
  opacity: 0.7;
}

@media (min-width: 640px) {

  .sm\\:mb-\\[25px\\] {
    margin-bottom: 25px;
  }

  .sm\\:block {
    display: block;
  }

  .sm\\:hidden {
    display: none;
  }

  .sm\\:w-\\[250px\\] {
    width: 250px;
  }

  .sm\\:w-\\[400px\\] {
    width: 400px;
  }

  .sm\\:w-\\[600px\\] {
    width: 600px;
  }

  .sm\\:min-w-\\[120px\\] {
    min-width: 120px;
  }

  .sm\\:max-w-\\[120px\\] {
    max-width: 120px;
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:gap-1\\.5 {
    gap: 0.375rem;
  }

  .sm\\:gap-4 {
    gap: 1rem;
  }

  .sm\\:p-\\[25px\\] {
    padding: 25px;
  }

  .sm\\:py-32 {
    padding-top: 8rem;
    padding-bottom: 8rem;
  }

  .sm\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .sm\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}

@media (min-width: 768px) {

  .md\\:w-\\[500px\\] {
    width: 500px;
  }

  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .md\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }
}

@media (min-width: 1024px) {

  .lg\\:w-\\[280px\\] {
    width: 280px;
  }

  .lg\\:w-\\[600px\\] {
    width: 600px;
  }

  .lg\\:w-\\[700px\\] {
    width: 700px;
  }

  .lg\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}

@media (min-width: 1280px) {

  .xl\\:w-\\[600px\\] {
    width: 600px;
  }

  .xl\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (prefers-color-scheme: dark) {

  .dark\\:border-amber-900\\/50 {
    border-color: rgb(120 53 15 / 0.5);
  }

  .dark\\:border-zinc-600 {
    --tw-border-opacity: 1;
    border-color: rgb(82 82 91 / var(--tw-border-opacity, 1));
  }

  .dark\\:border-zinc-700 {
    --tw-border-opacity: 1;
    border-color: rgb(63 63 70 / var(--tw-border-opacity, 1));
  }

  .dark\\:border-zinc-700\\/60 {
    border-color: rgb(63 63 70 / 0.6);
  }

  .dark\\:border-zinc-800 {
    --tw-border-opacity: 1;
    border-color: rgb(39 39 42 / var(--tw-border-opacity, 1));
  }

  .dark\\:bg-amber-950\\/40 {
    background-color: rgb(69 26 3 / 0.4);
  }

  .dark\\:bg-emerald-950\\/40 {
    background-color: rgb(2 44 34 / 0.4);
  }

  .dark\\:bg-zinc-800 {
    --tw-bg-opacity: 1;
    background-color: rgb(39 39 42 / var(--tw-bg-opacity, 1));
  }

  .dark\\:bg-zinc-800\\/60 {
    background-color: rgb(39 39 42 / 0.6);
  }

  .dark\\:bg-zinc-900 {
    --tw-bg-opacity: 1;
    background-color: rgb(24 24 27 / var(--tw-bg-opacity, 1));
  }

  .dark\\:text-amber-400 {
    --tw-text-opacity: 1;
    color: rgb(251 191 36 / var(--tw-text-opacity, 1));
  }

  .dark\\:text-emerald-300 {
    --tw-text-opacity: 1;
    color: rgb(110 231 183 / var(--tw-text-opacity, 1));
  }

  .dark\\:text-indigo-400 {
    --tw-text-opacity: 1;
    color: rgb(129 140 248 / var(--tw-text-opacity, 1));
  }

  .dark\\:text-white {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  }

  .dark\\:text-zinc-300 {
    --tw-text-opacity: 1;
    color: rgb(212 212 216 / var(--tw-text-opacity, 1));
  }

  .dark\\:text-zinc-400 {
    --tw-text-opacity: 1;
    color: rgb(161 161 170 / var(--tw-text-opacity, 1));
  }

  .dark\\:text-zinc-500 {
    --tw-text-opacity: 1;
    color: rgb(113 113 122 / var(--tw-text-opacity, 1));
  }

  .dark\\:hover\\:bg-gray-800:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;EAAd;;IAAA,wBAAc;IAAd,SAAc;EAAA;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;;AAKnB;EACE,2CAA2C;AAC7C;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iCAAiC;EACjC,4EAA4E;EAE5E,eAAe;EACf,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kEAAkE;AACpE;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE;wBACsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;AACtB;;AAiBA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAWA;;;;;;;;;;;;;;;;;;;;;;;GAuBG;;AAEH;EACE,wBAAwB;EACxB,uCAAuC;EACvC,wBAAwB;EACxB,uCAAuC;EACvC,6BAA6B;EAC7B,yCAAyC;EACzC,0BAA0B;EAC1B,4CAA4C;EAC5C,oBAAoB;EACpB,mCAAmC;EACnC,2BAA2B;EAC3B,0CAA0C;EAC1C,0BAA0B;EAC1B,yCAAyC;EACzC,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;EAGE,2CAA2C;AAC7C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oDAAoD;AACtD;;AAEA;;EAEE,sDAAsD;AACxD;;AAEA;EACE,oDAAoD;EACpD,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;EAC1C,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,uCAAuC;EACvC,uCAAuC;AACzC;;AAEA;;+EAE+E;;AAE/E,6CAA6C;AAC7C;EACE,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,4CAA4C;AAC5C;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,8CAAsC;EAAtC,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,+CAA+C;AAC/C;EACE,qCAAqC;EACrC,kBAAkB;EAClB,8CAAsC;EAAtC,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,qDAAqD;AACvD;;AAEA,sDAAsD;AACtD;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,8CAAsC;EAAtC,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,oDAAoD;EACpD,yCAAyC;EACzC,0BAA0B;EAC1B,2BAA2B;EAC3B,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oDAAoD;EACpD,4BAA4B;EAC5B,uBAAuB;EACvB,4BAA4B;EAC5B,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;;;oCAGkC;AACpC;;;AAGA;EACE,kBAAkB;EAClB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,2CAA2C;EAC3C,6BAA6B;AAC/B;;AAEA;EACE,8CAA8C;EAC9C,2CAA2C;EAC3C,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,yCAAyC;EACzC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,+CAA+C;EAC/C,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,2CAA2C;EAC3C,4CAA4C;EAC5C,8BAA8B;AAChC;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,6CAA6C;EAC7C,oBAAoB;AACtB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,kDAAkD;EAClD,6BAA6B;EAC7B,4BAA4B;EAC5B,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;EACvC,uBAAuB;EACvB,4BAA4B;EAC5B,oBAAoB;EACpB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,mDAAmD;EACnD,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,8BAA8B;EAC9B,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,oDAAoD;EACpD,uDAAuD;AACzD;;AAEA;;;;;;EAME,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,sDAAsD;AACxD;;AAEA;EACE,sDAAsD;EACtD,4CAA4C;EAC5C,iCAAiC;AACnC;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,mDAAmD;AACrD;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,+EAA+E;AAC/E;EACE,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA,sCAAsC;AACtC;EACE,2BAA2B;EAC3B,gDAAgD;EAChD,6BAA6B;AAC/B;;AAEA,+DAA+D;AAC/D;;;;EAIE,sDAAsD;EACtD,2CAA2C;EAC3C,6BAA6B;EAC7B,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA,yDAAyD;AACzD;;EAEE,mDAAmD;EACnD,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;;EAEE,mDAAmD;EACnD,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,mDAAmD;EACnD,2CAA2C;EAC3C,6BAA6B;AAC/B;;AAEA;EACE,mDAAmD;EACnD,2CAA2C;EAC3C,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,yDAAyD;AACzD;EACE,6BAA6B;AAC/B;;AAEA;EACE,oDAAoD;EACpD,2CAA2C;EAC3C,6BAA6B;EAC7B,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,yBAAyB;EACzB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,sDAAsD;EACtD,2CAA2C;AAC7C;;AAEA,+DAA+D;AAC/D;;EAEE,oCAAoC;EACpC,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;;EAEE,oCAAoC;EACpC,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,uCAAuC;EACvC,YAAY;AACd;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;;;;EAIE,2BAA2B;EAC3B,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,sEAAsE;EACtE,0EAA0E;AAC5E;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,uBAAuB;EACvB,yCAAyC;EACzC,0BAA0B;EAC1B,sDAAsD;AACxD;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;;GAEG;;AAEH;EACE,mEAAmE;EACnE,4DAA4D;EAC5D,gDAAgD;EAChD,wBAAwB;AAC1B;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;;EAEE,0BAA0B;EAC1B,oBAAwB;EACxB,+BAA+B;AACjC;;AAEA;;;;;;;;GAQG;;AAEH;EACE,+BAA+B;AACjC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,yCAAyC;EACzC,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,yFAAyF;EACzF,2BAA2B;EAC3B,qCAAqC;EACrC,kBAAkB;EAGlB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;;;wCAGsC;AACxC;;AAEA;;EAEE,6BAA6B;EAC7B,OAAO;EACP,cAAc;EACd,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;EACxC,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;EAEE;;IAEE,6BAA6B;IAC7B,4BAA4B;IAC5B,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;;;;;;;;;;KAWG;;EAEH;;;;;;;;IAQE,6BAA6B;EAC/B;;EAEA;;;;;;;;;;;;IAYE,6BAA6B;EAC/B;AACF;;AAEA;;EAEE;iBACe;EACf,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,kCAAkC;EAClC,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;;uBAEqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;;EAEE;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA,uBAAuB;AACvB;EACE,wBAAwB;EACxB,oCAAoC;EACpC,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA,6CAA6C;AAC7C;EACE,yBAAyB;EACzB,qBAAqB;EACrB,6BAA6B;AAC/B;;;AAGA,mBAAmB;AACnB;EACE,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA,qBAAqB;AACrB;EACE,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA,8CAA8C;AAC9C;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,aAAa;EACb,cAAc;AAChB;;AAEA,8DAA8D;AAC9D;EACE,cAAc;EACd,sBAAsB;EACtB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA,4CAA4C;AAC5C;;EAEE,6CAA6C;AAC/C;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,kDAAkD;EAClD,oDAAoD;AACtD;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,8DAA8D;EAC9D,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,yCAAyC;EACzC,wBAAwB;EACxB,2DAA2D;AAC7D;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,mCAAmC;AACnC;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAj6CA;EAAA;AAi6CC;;AAj6CD;EAAA,kBAi6CC;EAj6CD;AAi6CC;;AAj6CD;EAAA;AAi6CC;;AAj6CD;EAAA;AAi6CC;;AAj6CD;EAAA;AAi6CC;;AAj6CD;EAAA;AAi6CC;;AAj6CD;EAAA;AAi6CC;;AAj6CD;EAAA;AAi6CC;;AAj6CD;EAAA,kBAi6CC;EAj6CD;AAi6CC;;AAj6CD;EAAA;AAi6CC;;AAj6CD;EAAA,kBAi6CC;EAj6CD;AAi6CC;;AAj6CD;EAAA;AAi6CC;;AAj6CD;EAAA;AAi6CC;;AAj6CD;EAAA,oBAi6CC;EAj6CD;AAi6CC;;AAj6CD;EAAA,oBAi6CC;EAj6CD;AAi6CC;;AAj6CD;EAAA,oBAi6CC;EAj6CD;AAi6CC;;AAj6CD;EAAA;AAi6CC;;AAj6CD;EAAA;AAi6CC;;AAj6CD;EAAA;AAi6CC;;AAj6CD;EAAA;AAi6CC;;AAj6CD;EAAA,0EAi6CC;EAj6CD,8FAi6CC;EAj6CD;AAi6CC;;AAj6CD;EAAA;AAi6CC;;AAj6CD;EAAA;AAi6CC;;AAj6CD;EAAA;AAi6CC;;AAj6CD;EAAA,8BAi6CC;EAj6CD;AAi6CC;;AAj6CD;EAAA,2GAi6CC;EAj6CD,yGAi6CC;EAj6CD;AAi6CC;;AAj6CD;EAAA,2GAi6CC;EAj6CD,yGAi6CC;EAj6CD;AAi6CC;;AAj6CD;EAAA;AAi6CC;;AAj6CD;EAAA;AAi6CC;;AAj6CD;EAAA,8BAi6CC;EAj6CD;AAi6CC;;AAj6CD;EAAA,iBAi6CC;EAj6CD,iBAi6CC;EAj6CD;AAi6CC;;AAj6CD;EAAA,kBAi6CC;EAj6CD,kBAi6CC;EAj6CD;AAi6CC;;AAj6CD;EAAA;AAi6CC;;AAj6CD;EAAA;AAi6CC;;AAj6CD;EAAA;AAi6CC;;AAj6CD;EAAA,mBAi6CC;EAj6CD;AAi6CC;;AAj6CD;EAAA;AAi6CC;;AAj6CD;EAAA;AAi6CC;;AAj6CD;;EAAA;IAAA;EAi6CC;;EAj6CD;IAAA;EAi6CC;;EAj6CD;IAAA;EAi6CC;;EAj6CD;IAAA;EAi6CC;;EAj6CD;IAAA;EAi6CC;;EAj6CD;IAAA;EAi6CC;;EAj6CD;IAAA;EAi6CC;;EAj6CD;IAAA;EAi6CC;;EAj6CD;IAAA;EAi6CC;;EAj6CD;IAAA;EAi6CC;;EAj6CD;IAAA;EAi6CC;;EAj6CD;IAAA;EAi6CC;;EAj6CD;IAAA,iBAi6CC;IAj6CD;EAi6CC;;EAj6CD;IAAA,eAi6CC;IAj6CD;EAi6CC;;EAj6CD;IAAA,mBAi6CC;IAj6CD;EAi6CC;;EAj6CD;IAAA,mBAi6CC;IAj6CD;EAi6CC;AAAA;;AAj6CD;;EAAA;IAAA;EAi6CC;;EAj6CD;IAAA;EAi6CC;;EAj6CD;IAAA;EAi6CC;;EAj6CD;IAAA,iBAi6CC;IAj6CD;EAi6CC;AAAA;;AAj6CD;;EAAA;IAAA;EAi6CC;;EAj6CD;IAAA;EAi6CC;;EAj6CD;IAAA;EAi6CC;;EAj6CD;IAAA,kBAi6CC;IAj6CD;EAi6CC;AAAA;;AAj6CD;;EAAA;IAAA;EAi6CC;;EAj6CD;IAAA;EAi6CC;AAAA;;AAj6CD;;EAAA;IAAA;EAi6CC;;EAj6CD;IAAA,sBAi6CC;IAj6CD;EAi6CC;;EAj6CD;IAAA,sBAi6CC;IAj6CD;EAi6CC;;EAj6CD;IAAA;EAi6CC;;EAj6CD;IAAA,sBAi6CC;IAj6CD;EAi6CC;;EAj6CD;IAAA;EAi6CC;;EAj6CD;IAAA;EAi6CC;;EAj6CD;IAAA,kBAi6CC;IAj6CD;EAi6CC;;EAj6CD;IAAA;EAi6CC;;EAj6CD;IAAA,kBAi6CC;IAj6CD;EAi6CC;;EAj6CD;IAAA,oBAi6CC;IAj6CD;EAi6CC;;EAj6CD;IAAA,oBAi6CC;IAj6CD;EAi6CC;;EAj6CD;IAAA,oBAi6CC;IAj6CD;EAi6CC;;EAj6CD;IAAA,oBAi6CC;IAj6CD;EAi6CC;;EAj6CD;IAAA,oBAi6CC;IAj6CD;EAi6CC;;EAj6CD;IAAA,oBAi6CC;IAj6CD;EAi6CC;;EAj6CD;IAAA,oBAi6CC;IAj6CD;EAi6CC;;EAj6CD;IAAA,kBAi6CC;IAj6CD;EAi6CC;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n@import './ShopeasyUiKit.css';\n@import './Media.css';\n\n\n* {\n  font-family: 'Inter', sans-serif !important;\n}\n\n.ql-font-serif {\n  font-family: 'Instrument Serif', serif !important;\n}\n\n.ql-font-monospace {\n  font-family: 'Space Mono', monospace !important;\n}\n\n.loader {\n  width: 70px;\n  padding: 5px;\n  aspect-ratio: 1;\n  border-radius: 50%;\n  background: var(--btn-bg-primary);\n  --_m: conic-gradient(#0000 10%, #000), linear-gradient(#000 0 0) content-box;\n  -webkit-mask: var(--_m);\n  mask: var(--_m);\n  -webkit-mask-composite: source-out;\n  animation: l3 1s infinite linear;\n}\n\n@keyframes l3 {\n  to {\n    transform: rotate(1turn);\n  }\n}\n\n.menu-dropdown {\n  transition: all 0.5s;\n}\n\n.menu-dropdown .close {\n  opacity: 0;\n  visibility: hidden;\n  height: 0;\n  transition: all 0.5s;\n  margin-left: 20px;\n}\n\n.bg {\n  background-color: #74ebd5;\n  background-image: linear-gradient(90deg, #74ebd5 0%, #9face6 100%);\n}\n\n.bg .form {\n  box-shadow: 0 20px 45px 0 rgb(0, 0, 0, 0.2);\n}\n\n.menu-dropdown .open {\n  /* opacity: 1;\n  visibility: visible; */\n  /* height: 100%; */\n  transition: all 0.5s;\n  margin-left: 20px;\n  animation: menu 5s 1;\n}\n\n@layer utilities {\n  .no-scrollbar::-webkit-scrollbar {\n    display: none;\n  }\n\n  .no-scrollbar {\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n  }\n\n  .page-header-pb {\n    @apply pb-[20px];\n  }\n}\n\n.ql-snow .ql-editor h1 {\n  font-size: 40px !important;\n}\n\n.ql-snow .ql-editor h2 {\n  font-size: 36px !important;\n}\n\n.ql-snow .ql-editor h3 {\n  font-size: 32px !important;\n}\n\n.ql-snow .ql-editor h4 {\n  font-size: 28px !important;\n}\n\n.ql-snow .ql-editor h5 {\n  font-size: 24px !important;\n}\n\n.ql-snow .ql-editor h6 {\n  font-size: 20px !important;\n}\n\n@layer base {\n\n  input[type='number']::-webkit-inner-spin-button,\n  input[type='number']::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n}\n\n/* :root {\n  --sidebar-bg-color: #28282b;\n  --sidebar-bg-color-rgb: 40, 40, 43;\n  --btn-bg-primary: #28282b;\n  --btn-bg-primary-rgb: rgb(40, 40, 43);\n  --bg-btn-hover: #000000;\n  --bg-btn-hover-rgb: rgb(0, 0, 0);\n  --primary-bg-color: #f6f6f7;\n  --primary-bg-color-rgb: 246, 246, 247;\n  --secondary-bg-color: #ffffff;\n  --secondary-bg-color-rgb: rgb(255, 255, 255);\n  --primary-text-color: #202223;\n  --primary-text-color-rgb: rgb(32, 34, 35);\n  --border-color: #e1e3e5;\n  --border-color-rgb: 225, 227, 229;\n  --focus-border-color: #8c9196;\n  --focus-border-color-rgb: rgb(140, 145, 150);\n  --focus-tab-color: #f1f2f3;\n  --focus-tab-color-rgb: rgb(241, 242, 243);\n  --table-text-color: #6b7280;\n  --table-text-color-rgb: rgb(107, 114, 128);\n  --tawk-header-background-color: var(--sidebar-bg-color);\n  --tawk-header-background-color-rgb: var(var(--sidebar-bg-color-rgb));\n} */\n\n.dark-mode {\n  --sidebar-bg-color: #111;\n  --sidebar-bg-color-rgb: rgb(17, 17, 17);\n  --primary-bg-color: #222;\n  --primary-bg-color-rgb: rgb(34, 34, 34);\n  --secondary-bg-color: #333333;\n  --secondary-bg-color-rgb: rgb(51, 51, 51);\n  --primary-text-color: #ccc;\n  --primary-text-color-rgb: rgb(204, 204, 204);\n  --border-color: #444;\n  --border-color-rgb: rgb(68, 68, 68);\n  --table-text-color: #a0a0a0;\n  --table-text-color-rgb: rgb(160, 160, 160);\n  --focus-border-color: #555;\n  --focus-border-color-rgb: rgb(85, 85, 85);\n  --focus-tab-color: #444;\n  --focus-tab-color-rgb: rgb(68, 68, 68);\n}\n\nbody {\n  color: var(--primary-text-color);\n}\n\n.dark-mode .bg-white,\n.dark-mode .bg-gray-50,\n.dark-mode .bg-gray-100 {\n  background-color: var(--secondary-bg-color);\n}\n\n.dark-mode .hover\\:bg-gray-100:hover {\n  background-color: var(--focus-tab-color);\n}\n\n.primary-text-color {\n  color: var(--primary-text-color);\n}\n\n.plan-popup .MuiBackdrop-root.MuiModal-backdrop {\n  background-color: initial !important;\n}\n\n.primary-bg-color {\n  background-color: var(--primary-bg-color) !important;\n}\n\n.secondary-bg-color,\n.cTsUPQ {\n  background-color: var(--secondary-bg-color) !important;\n}\n\n.MuiLinearProgress-root {\n  background-color: var(--sidebar-bg-color) !important;\n  height: 3px !important;\n}\n\n.MuiLinearProgress-bar {\n  background-color: white !important;\n  transition: transform 2s linear !important;\n  width: 80% !important;\n  right: 0 !important;\n}\n\n.text-btn {\n  color: var(--btn-bg-primary);\n}\n\n.table-text {\n  color: var(--table-text-color) !important;\n}\n\n.bg-btn {\n  background-color: var(--btn-bg-primary);\n  border: 1px solid var(--btn-bg-primary);\n}\n\n/* ==========================================================================\n   SCROLLBAR STYLING (Consolidated in One Place)\n   ========================================================================== */\n\n/* Hide Scrollbar Buttons / Arrows Globally */\n::-webkit-scrollbar-button {\n  display: none !important;\n  width: 0 !important;\n  height: 0 !important;\n}\n\n/* WebKit Scrollbar (Chrome, Safari, Edge) */\n::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: rgba(0, 0, 0, 0.25);\n  border-radius: 6px;\n  transition: background-color 0.3s ease;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background-color: rgba(0, 0, 0, 0.45);\n}\n\n/* Standard Custom Scrollbar (Always Visible) */\n.custom-scrollbar::-webkit-scrollbar-thumb {\n  background-color: rgba(0, 0, 0, 0.25);\n  border-radius: 6px;\n  transition: background-color 0.3s ease;\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb:hover {\n  background-color: rgba(0, 0, 0, 0.45);\n}\n\n.dark-mode .custom-scrollbar::-webkit-scrollbar-thumb {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n.custom-scrollbar {\n  scrollbar-width: thin;\n  scrollbar-color: rgba(0, 0, 0, 0.25) transparent;\n}\n\n.dark-mode .custom-scrollbar {\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n}\n\n/* Sidebar Scrollbar - Visible ONLY on Sidebar Hover */\n.sidebar-scrollbar::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n.sidebar-scrollbar::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.sidebar-scrollbar::-webkit-scrollbar-thumb {\n  background-color: transparent;\n  border-radius: 6px;\n  transition: background-color 0.3s ease;\n}\n\n.sidebar-scrollbar:hover::-webkit-scrollbar-thumb {\n  background-color: rgba(0, 0, 0, 0.25);\n}\n\n.sidebar-scrollbar:hover::-webkit-scrollbar-thumb:hover {\n  background-color: rgba(0, 0, 0, 0.45);\n}\n\n.dark-mode .sidebar-scrollbar::-webkit-scrollbar-thumb {\n  background-color: transparent;\n}\n\n.dark-mode .sidebar-scrollbar:hover::-webkit-scrollbar-thumb {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n.dark-mode .sidebar-scrollbar:hover::-webkit-scrollbar-thumb:hover {\n  background-color: rgba(255, 255, 255, 0.4);\n}\n\n.sidebar-scrollbar {\n  scrollbar-width: thin;\n  scrollbar-color: transparent transparent;\n}\n\n.sidebar-scrollbar:hover {\n  scrollbar-color: rgba(0, 0, 0, 0.25) transparent;\n}\n\n.dark-mode .sidebar-scrollbar:hover {\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n}\n\n.sidebar {\n  transition: all 0.3s;\n  min-width: 300px;\n  max-width: 300px;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 0;\n  flex-shrink: 1;\n  min-height: 1px;\n}\n\n.sidebar button:focus,\n.sidebar a:focus {\n  outline: none;\n}\n\n.MuiBadge-badge {\n  background-color: var(--sidebar-bg-color) !important;\n  color: var(--primary-bg-color) !important;\n  font-size: 12px !important;\n  font-weight: 500 !important;\n  top: -1px !important;\n  right: -2px !important;\n}\n\n.dark-mode .MuiBadge-badge {\n  color: var(--table-text-color) !important;\n}\n\n.notification .MuiPaper-root.MuiPaper-elevation {\n  border-radius: 4px 0 0 4px;\n}\n\n.my-tooltip-class.MuiTooltip-tooltip {\n  background-color: var(--sidebar-bg-color) !important;\n  padding: 8px 16px !important;\n  color: white !important;\n  margin-left: 20px !important;\n  font-size: 13px !important;\n  letter-spacing: 1px;\n}\n\n.my-tooltip-class .MuiTooltip-arrow::before {\n  background: var(--sidebar-bg-color) !important;\n}\n\n.sidebar.close {\n  width: 60px;\n  min-width: 60px;\n  max-width: 60px;\n}\n\n.close .sidebar {\n  width: 60px;\n  min-width: 60px;\n  max-width: 60px;\n}\n\n.absolute-loader {\n  width: 100%;\n  height: 100%;\n  /* position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%,-50%); */\n}\n\n\n.tooltip-perent {\n  position: relative;\n  display: block;\n  transition: all 0.3s;\n}\n\n.tooltip {\n  position: absolute;\n  left: -70%;\n  top: 130%;\n  opacity: 0;\n  transition: all 0.3s;\n}\n\n.popup-content .MuiPaper-root.MuiPopover-paper {\n  position: absolute !important;\n  z-index: 20 !important;\n  left: 50% !important;\n  top: 50% !important;\n  transform: translate(-50%, -50%) !important;\n  border-radius: 4px !important;\n}\n\n.tooltip-arrow {\n  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);\n  background-color: var(--primary-text-color);\n  width: 10px;\n  height: 6px;\n  position: absolute;\n  top: -2px;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.tooltip-perent:hover .tooltip {\n  opacity: 1;\n}\n\n.nb-spinner,\n.nb-spinner-small {\n  display: inline-block;\n  width: 30px;\n  height: 30px;\n  border: 4px solid var(--primary-text-color);\n  border-top: 4px solid var(--border-color);\n  border-radius: 50%;\n  animation: spin 2s linear infinite;\n}\n\n.nb-spinner-small {\n  width: 20px;\n  height: 20px;\n  border: 2px solid var(--primary-text-color);\n  border-top: 2px solid var(--border-color);\n}\n\n.data-loader {\n  display: inline-block;\n  width: 50px;\n  height: 50px;\n  border: 4px solid var(--border-color);\n  border-top: 4px solid var(--primary-text-color);\n  border-radius: 50%;\n  animation: spin 2s linear infinite;\n}\n\n.custom-toast {\n  font-size: 10px !important;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.pagination {\n  background-color: var(--secondary-bg-color);\n  border-color: var(--border-color) !important;\n  color: var(--table-text-color);\n}\n\n.pagination .MuiButtonBase-root.MuiPaginationItem-root.Mui-selected {\n  background-color: var(--primary-bg-color);\n  border-radius: 100%;\n}\n\n.pagination .MuiButtonBase-root.MuiPaginationItem-root.MuiPaginationItem-text {\n  color: var(--table-text-color);\n}\n\n.pagination .MuiButtonBase-root.MuiPaginationItem-root.MuiPaginationItem-text:hover {\n  background-color: var(--primary-bg-color) !important;\n}\n\n.pagination .selected {\n  border: none !important;\n}\n\n.active {\n  color: white !important;\n}\n\n.detail-container {\n  padding: 0 !important;\n}\n\n.text-primary {\n  color: var(--primary-text-color) !important;\n}\n\n.text-link {\n  /* color: var(--btn-bg-primary) !important; */\n  transition: all 0.3s;\n}\n\n.text-link:hover {\n  /* color: var(--btn-bg-primary) !important; */\n}\n\n.page_builder_container:hover {\n  border: 2px solid var(--btn-bg-primary);\n}\n\n.ql-toolbar.ql-snow+.ql-container.ql-snow {\n  border-radius: 0px 0px 4px 4px !important;\n}\n\n.ql-toolbar.ql-snow {\n  border-radius: 4px 4px 0px 0px !important;\n}\n\n.bg-primary {\n  background-color: var(--sidebar-bg-color) !important;\n}\n\n.btn {\n  background-color: var(--btn-bg-primary) !important;\n  border-radius: 4px !important;\n  padding: 8px 20px !important;\n  border: 1px solid var(--btn-bg-primary);\n}\n\n.secondary-btn {\n  border: 1px solid var(--btn-bg-primary);\n  background-color: white;\n  color: var(--btn-bg-primary);\n  transition: all 0.3s;\n  border-radius: 4px !important;\n  padding: 8px 20px !important;\n}\n\n.ql-editor {\n  min-height: 150px !important;\n  max-height: auto;\n}\n\n.ql-editor.elementor-editor {\n  min-height: unset !important;\n}\n\n.main-border-color {\n  border-color: var(--border-color) !important;\n}\n\n.focus-border-color {\n  border-color: var(--focus-border-color) !important;\n}\n\n.focus-tab {\n  background-color: var(--focus-tab-color) !important;\n  color: var(--primary-text-color) !important;\n}\n\n.tab {\n  padding: 8px 15px;\n  background-color: transparent;\n  font-size: 12px;\n  line-height: 13px;\n  border-radius: 4px;\n  text-transform: capitalize;\n  font-weight: 500;\n  color: var(--table-text-color);\n  transition: all 0.2s;\n  display: inline-block;\n}\n\n.file-tag-hover .tab {\n  padding: 8px 10px !important;\n  border-radius: 30px !important;\n}\n\n.tab:hover {\n  color: var(--primary-text-color);\n}\n\n.border-secondary {\n  border: 1px solid var(--btn-bg-primary);\n}\n\n.react-datepicker__header {\n  background-color: var(--primary-bg-color) !important;\n  border-bottom: 1px solid var(--border-color) !important;\n}\n\n.react-datepicker__current-month,\n.react-datepicker-time__header,\n.react-datepicker-year-header,\n.react-datepicker__day-name,\n.react-datepicker__day,\n.react-datepicker__time-name {\n  color: var(--primary-text-color) !important;\n}\n\n.react-datepicker__month {\n  margin: 0 !important;\n  padding: 0.4rem !important;\n  background-color: var(--secondary-bg-color) !important;\n}\n\n.react-datepicker {\n  background-color: var(--secondary-bg-color) !important;\n  border-color: var(--border-color) !important;\n  box-shadow: var(--shadow-popover);\n}\n\n.react-datepicker__month-container {\n  background-color: var(--secondary-bg-color) !important;\n}\n\n.react-datepicker-wrapper {\n  width: 100% !important;\n}\n\n.react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::before,\n.react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::after {\n  border-bottom-color: var(--border-color) !important;\n}\n\n.react-datepicker__day.react-datepicker__day--disabled {\n  opacity: 40% !important;\n  cursor: not-allowed;\n}\n\n/* Keyboard focus when calendar opens should not force an ugly background box */\n.react-datepicker__day--keyboard-selected {\n  background-color: transparent !important;\n  color: var(--primary-text-color) !important;\n}\n\n/* Subtle indicator for today's date */\n.react-datepicker__day--today {\n  font-weight: 600 !important;\n  border: 1px solid var(--border-color) !important;\n  border-radius: 4px !important;\n}\n\n/* Selected dates and range endpoints — using theme variables */\n.react-datepicker__day--selected,\n.react-datepicker__day--range-start,\n.react-datepicker__day--range-end,\n.react-datepicker__day--keyboard-selected.react-datepicker__day--selected {\n  background-color: var(--primary-text-color) !important;\n  color: var(--secondary-bg-color) !important;\n  border-radius: 4px !important;\n  font-weight: 600 !important;\n  border: none !important;\n}\n\n/* In-between range dates — using theme focus tab color */\n.react-datepicker__day--in-range,\n.react-datepicker__day--in-selecting-range {\n  background-color: var(--focus-tab-color) !important;\n  color: var(--primary-text-color) !important;\n  border-radius: 0 !important;\n}\n\n.dark-mode .react-datepicker__day--in-range,\n.dark-mode .react-datepicker__day--in-selecting-range {\n  background-color: var(--focus-tab-color) !important;\n  color: var(--primary-text-color) !important;\n  border-radius: 0 !important;\n}\n\n.react-datepicker__day:hover {\n  background-color: var(--focus-tab-color) !important;\n  color: var(--primary-text-color) !important;\n  border-radius: 4px !important;\n}\n\n.dark-mode .react-datepicker__day:hover {\n  background-color: var(--focus-tab-color) !important;\n  color: var(--primary-text-color) !important;\n  border-radius: 4px !important;\n}\n\n.react-datepicker-popper {\n  z-index: 35 !important;\n}\n\n/* DatePicker Clear (X) button — UI theme native colors */\n.react-datepicker__close-icon {\n  padding: 0 4px 0 0 !important;\n}\n\n.react-datepicker__close-icon::after {\n  background-color: var(--table-text-color) !important;\n  color: var(--secondary-bg-color) !important;\n  border-radius: 50% !important;\n  font-size: 11px !important;\n  width: 15px !important;\n  height: 15px !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  line-height: 1 !important;\n  padding: 0 !important;\n  transition: all 0.2s ease !important;\n}\n\n.react-datepicker__close-icon:hover::after {\n  background-color: var(--primary-text-color) !important;\n  color: var(--secondary-bg-color) !important;\n}\n\n/* Fix DatePicker input text visibility inside filter popover */\n.filter .react-datepicker__input-container input,\n.filter input.react-datepicker-ignore-onclickoutside {\n  background-color: #ffffff !important;\n  color: #111111 !important;\n  padding: 6px 10px !important;\n}\n\n.dark-mode .filter .react-datepicker__input-container input,\n.dark-mode .filter input.react-datepicker-ignore-onclickoutside {\n  background-color: #2a2a2a !important;\n  color: #e0e0e0 !important;\n  border-color: #555 !important;\n}\n\n.secondary-btn:hover {\n  background-color: var(--btn-bg-primary);\n  color: white;\n}\n\n.btn:hover {\n  background-color: var(--bg-btn-hover) !important;\n}\n\n.border-primary {\n  border-color: var(--sidebar-bg-color);\n}\n\n.border-primary-color {\n  border-color: var(--btn-bg-primary) !important;\n}\n\n.info-link {\n  color: #7f7f7f;\n  transition: all 0.3s;\n}\n\n.info-link:hover {\n  color: #616161;\n}\n\n.fwGovb {\n  font-weight: 700 !important;\n  text-transform: uppercase;\n}\n\n.rdt_TableCell {\n  color: var(--table-text-color);\n  font-weight: 400;\n  font-size: 13px;\n  letter-spacing: 0.5px;\n}\n\n.gVZIpW,\n.dMnwYK:nth-of-type(n) {\n  height: 55px !important;\n}\n\n.variant-table .gVZIpW,\n.variant-table .dMnwYK:nth-of-type(n),\n.delete-logs .gVZIpW,\n.delete-logs .dMnwYK:nth-of-type(n) {\n  min-height: 55px !important;\n  height: auto !important;\n  padding: 5px 0 !important;\n}\n\n.sticky-column {\n  position: sticky !important;\n  left: 0 !important;\n  background-color: inherit !important;\n  z-index: 5 !important;\n}\n\n.gVZIpW:not(:last-of-type) {\n  border-bottom: 1px solid rgba(var(--border-color-rgb), 70%) !important;\n  /* border-top: 0.5px solid rgba(var(--border-color-rgb),70%) !important; */\n}\n\n.dark-mode .gVZIpW:not(:last-of-type) {\n  border-bottom: 1px solid var(--border-color) !important;\n}\n\n.dashboard .gVZIpW {\n  height: 45px !important;\n  color: var(--table-text-color) !important;\n  font-size: 12px !important;\n  background-color: var(--secondary-bg-color) !important;\n}\n\n.gVZIpW {\n  background-color: var(--secondary-bg-color) !important;\n}\n\n.cTsUPQ {\n  color: var(--table-text-color) !important;\n  min-height: 280px !important;\n}\n\n.rdt_TableRow {\n  cursor: pointer;\n}\n\n/* .gVZIpW {\n  border-top: 0.5px solid var(--border-color) !important;\n} */\n\n.gVZIpW:hover {\n  background-color: rgba(var(--primary-bg-color-rgb), 70%) !important;\n  /* border-top: 0.5px solid var(--border-color) !important; */\n  border-color: rgba(var(--border-color-rgb), 70%);\n  outline: none !important;\n}\n\n.dark-mode .gVZIpW:hover {\n  background-color: var(--btn-bg-primary) !important;\n}\n\n.drag-btn {\n  opacity: 0;\n}\n\n.gVZIpW:hover .drag-btn {\n  opacity: 1;\n}\n\n.cRzJdb,\n.sc-kpDqfm {\n  margin-left: 10px !important;\n  font-size: 8px;\n}\n\n.dIyxTF,\n.jDsDCL {\n  min-width: 30px !important;\n  flex: 0 0 0px !important;\n  justify-content: end !important;\n}\n\n/* .MuiAutocomplete-hasPopupIcon.css-1h51icj-MuiAutocomplete-root .MuiOutlinedInput-root,\n.MuiAutocomplete-hasClearIcon.css-1h51icj-MuiAutocomplete-root .MuiOutlinedInput-root {\n  padding: 5px !important;\n}\n\n.MuiAutocomplete-hasPopupIcon.css-1h51icj-MuiAutocomplete-root .MuiOutlinedInput-root,\n.MuiAutocomplete-hasClearIcon.css-1h51icj-MuiAutocomplete-root .MuiOutlinedInput-root {\n  padding: 2px 4px !important;\n} */\n\n.css-nxo287-MuiInputBase-input-MuiOutlinedInput-input {\n  padding: 10.5px 14px !important;\n}\n\n.faq-autocomplete.css-1h51icj-MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input {\n  color: var(--primary-text-color) !important;\n}\n\n.MuiInputBase-root.Mui-focused {\n  border: none !important;\n  outline: none !important;\n}\n\n.myDIV {\n  background-color: black;\n}\n\n.apexcharts-reset-icon,\n.apexcharts-pan-icon {\n  display: none;\n}\n\n.apexcharts-toolbar {\n  display: none !important;\n}\n\n.breadcrumb-divider {\n  position: relative;\n  margin-right: 18px;\n  display: inline-block;\n}\n\n.breadcrumb-divider::after {\n  content: '';\n  width: 9px;\n  height: 100%;\n  border-top: 1px solid var(--border-color);\n  transform: rotate(-70deg);\n  position: absolute;\n  right: -20px;\n  top: 4px;\n}\n\n.card {\n  position: relative;\n  display: flex;\n  width: 450px;\n  flex-direction: column;\n  min-width: 0;\n  word-wrap: break-word;\n  background: linear-gradient(rgba(255, 255, 255, 0.12) 0%, var(--secondary-bg-color) 100%);\n  background-clip: border-box;\n  border: 1px solid var(--border-color);\n  border-radius: 4px;\n  -webkit-box-shadow: 0px 0px 5px 0px rgb(249, 249, 250);\n  -moz-box-shadow: 0px 0px 5px 0px rgba(212, 182, 212, 1);\n  box-shadow: 0px 0px 5px 0px rgb(161, 163, 164);\n}\n\n.card .card-body {\n  padding: 1rem 1rem;\n}\n\n.card-body {\n  flex: 1 1 auto;\n  padding: 1.25rem;\n}\n\np {\n  font-size: 14px;\n}\n\n.cross {\n  padding: 10px;\n  color: #d6312d;\n  cursor: pointer;\n}\n\n.continue:focus {\n  outline: none;\n}\n\n.continue {\n  border-radius: 4px;\n  text-transform: capitalize;\n  font-size: 13px;\n  padding: 8px 19px;\n  cursor: pointer;\n  color: var(--primary-bg-color);\n  background-color: #d50000;\n}\n\n.continue:hover {\n  background-color: #d32f2f !important;\n}\n\n.cart-items .css-3bmhjh-MuiPaper-root-MuiPopover-paper {\n  box-shadow:\n    0px 5px 5px -3px rgba(0, 0, 0, 0.2),\n    0px 8px 10px 1px rgba(0, 0, 0, 0.14),\n    0px 3px 14px 2px rgba(0, 0, 0, 0.12);\n}\n\n.react-colorful,\n.w-color-swatch.w-color-github.w-color-chrome {\n  position: absolute !important;\n  left: 0;\n  display: block;\n  top: 100%;\n  z-index: 999999 !important;\n}\n\n.kubBPN:hover {\n  background-color: transparent !important;\n  color: black !important;\n}\n\n.kubBPN:focus {\n  background-color: transparent !important;\n}\n\n@media (max-width: 767px) {\n\n  .btn,\n  .secondary-btn {\n    border-radius: 4px !important;\n    padding: 6px 10px !important;\n    font-size: 12px !important;\n  }\n\n  .back-arrow {\n    display: none;\n  }\n\n  .filter-btn {\n    width: 35px;\n    height: 35px;\n  }\n\n  /* input[type=\"text\"],\n  input[type=\"number\"],\n  input[type=\"Number\"],\n  input[type=\"email\"],\n  input[type=\"password\"],\n  input[type=\"date\"],\n  select,\n  textarea {\n    padding: 6px 12px !important;\n    font-size: 14px !important;\n    line-height: 20px !important;\n  } */\n\n  .sticky-table .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(3),\n  .sticky-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(3),\n  .customer-table .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(3),\n  .customer-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(3),\n  .category-table .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(2),\n  .category-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(2),\n  .add-variant-table table thead tr td:first-child,\n  .add-variant-table table tbody tr td:first-child {\n    position: relative !important;\n  }\n\n  .sticky-table .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:last-child,\n  .sticky-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child,\n  .product-table .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:last-child,\n  .product-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child,\n  .category-table .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:last-child,\n  .category-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child,\n  .blog-table .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:last-child,\n  .blog-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child,\n  .customer-table .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-last-child(2),\n  .customer-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-last-child(2),\n  .add-discount-table table thead tr td:last-child,\n  .add-discount-table table tbody tr td:last-child {\n    position: relative !important;\n  }\n}\n\n.slick-next,\n.slick-prev {\n  /* background: black !important;\n  opacity: 75%; */\n  color: white !important;\n  width: 30px !important;\n  height: 30px !important;\n  border-radius: 50%;\n  z-index: 9 !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.slick-next {\n  right: -36px !important;\n}\n\n.slick-prev {\n  left: -36px !important;\n}\n\n.main-slider .slick-prev {\n  left: 36px !important;\n}\n\n.main-slider .slick-next {\n  right: 36px !important;\n}\n\n.slick-prev:before,\n.slick-next:before {\n  content: '' !important;\n}\n\n.custom-prev-arrow,\n.custom-next-arrow {\n  /* Your custom styles for arrows */\n  background-color: blue;\n  color: white;\n  border-radius: 50%;\n  padding: 10px;\n  cursor: pointer;\n}\n\n.css-5ryogn-MuiButtonBase-root-MuiSwitch-switchBase.Mui-checked.Mui-disabled {\n  color: white !important;\n}\n\ninput[type='radio'] {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  width: 20px;\n  height: 20px;\n  border: 2px solid black;\n  border-radius: 50%;\n  outline: none;\n  cursor: pointer;\n  position: relative;\n}\n\ninput[type='radio']:checked::before {\n  content: '';\n  display: block;\n  width: 12px;\n  height: 12px;\n  background-color: black;\n  border-radius: 50%;\n  position: absolute;\n  top: 2px;\n  left: 2px;\n}\n\n.css-j204z7-MuiFormControlLabel-root {\n  margin-right: 0 !important;\n}\n\n.css-j204z7-MuiFormControlLabel-root.Mui-disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.css-143ulsi-JoySnackbar-endDecorator button {\n  transition:\n    background-color 0.3s ease,\n    transform 0.3s ease;\n}\n\n.css-143ulsi-JoySnackbar-endDecorator button:hover {\n  background-color: rgba(0, 0, 0, 0.1);\n  transform: scale(1.1);\n}\n\n.bold-date {\n  font-weight: bold;\n}\n\n.order-table .cTsUPQ {\n  min-height: 72px !important;\n}\n\n.dragLine {\n  border: none !important;\n}\n\n@keyframes slideIn {\n  0% {\n    transform: translateY(-100%);\n  }\n\n  100% {\n    transform: translateY(0);\n  }\n}\n\n.animate-slideIn {\n  animation: slideIn 0.5s ease-out forwards;\n}\n\n@keyframes bounceDelayed {\n\n  0%,\n  100% {\n    transform: translateY(0);\n  }\n\n  50% {\n    transform: translateY(-5px);\n  }\n}\n\n.typing-dot {\n  animation: bounceDelayed 0.6s infinite ease-in-out;\n}\n\n.typing-dot:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.typing-dot:nth-child(3) {\n  animation-delay: 0.4s;\n}\n\n.marquee-wrapper {\n  width: 100%;\n  overflow: hidden;\n}\n\n.marquee-text {\n  display: flex;\n  animation: marqueeLeftToRight 10s linear infinite;\n}\n\n.marquee-text p {\n  white-space: nowrap;\n  color: #222;\n  font-size: 15px;\n  padding: 5px;\n}\n\n@keyframes marqueeLeftToRight {\n  0% {\n    transform: translateX(0);\n  }\n\n  100% {\n    transform: translateX(-50%);\n  }\n}\n\n/* Base slider styles */\n.custom-slider {\n  -webkit-appearance: none;\n  /* Removes default browser styling */\n  width: 100%;\n  height: 6px;\n  background: #e5e5e5;\n  /* Track background color */\n  border-radius: 3px;\n  outline: none;\n  cursor: pointer;\n}\n\n.custom-slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 20px;\n  height: 20px;\n  background: #000;\n  border-radius: 50%;\n  cursor: pointer;\n  border: 2px solid #fff;\n}\n\n.custom-slider::-moz-range-thumb {\n  width: 20px;\n  height: 20px;\n  background: #000;\n  border-radius: 50%;\n  cursor: pointer;\n  border: 2px solid #fff;\n}\n\n.custom-slider::-ms-thumb {\n  width: 20px;\n  height: 20px;\n  background: #000;\n  border-radius: 50%;\n  cursor: pointer;\n  border: 2px solid #fff;\n}\n\n/* Change ReactQuill placeholder text color */\n.ql-editor.ql-blank::before {\n  color: #9ca3af !important;\n  opacity: 1 !important;\n  font-style: normal !important;\n}\n\n\n/* ✅ Ordered List */\n.editor-area ol {\n  list-style-type: decimal !important;\n  padding-left: 1.5rem;\n}\n\n/* ✅ Unordered List */\n.editor-area ul {\n  list-style-type: disc !important;\n  padding-left: 1.5rem;\n}\n\n/* ✅ Proper Heading Styling (FIXED selector) */\n.editor-area h1 {\n  font-size: 32px;\n  font-weight: 700;\n}\n\n.editor-area h2 {\n  font-size: 24px;\n  font-weight: 700;\n}\n\n.editor-area h3 {\n  font-size: 18.72px;\n  font-weight: 600;\n}\n\n.editor-area h4 {\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.editor-area h5 {\n  font-size: 13.28px;\n  font-weight: 500;\n}\n\n.editor-area h6 {\n  font-size: 12px;\n  font-weight: 500;\n}\n\n/* ✅ Paragraph spacing */\n.editor-area p {\n  margin-bottom: 16px;\n}\n\n/* ✅ Code view protection */\n.editor-area pre {\n  white-space: pre-wrap;\n}\n\n.editor-area hr {\n  border: none;\n  border-top: 1px solid #d1d5db;\n  /* gray-300 */\n  margin: 16px 0;\n}\n\n/* ✅ Universal Link Style (Editor + CodeView + Live Article) */\n.editor-area a {\n  color: #2563eb;\n  /* Tailwind blue-600 */\n  text-decoration: underline;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.editor-area a:hover {\n  color: #1d4ed8;\n  /* Tailwind blue-700 */\n}\n\n.tooltip-root:hover .tooltip-box {\n  opacity: 1;\n  transform: scale(1);\n}\n\n.input-datepicker {\n  border-radius: 8px !important;\n  box-shadow: none !important;\n  font-size: 14px !important;\n  font-weight: 400 !important;\n  line-height: 20px !important;\n  outline: none !important;\n  padding: 8px 12px !important;\n}\n\n.input-datepicker:focus {\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n/* ── Dark Mode Compatibility Overrides ── */\n.dark-mode .text-indigo-600,\n.dark-mode .text-indigo-500 {\n  color: var(--secondary-text-color) !important;\n}\n\n.dark-mode .text-gray-900,\n.dark-mode .text-gray-800 {\n  color: var(--primary-text-color) !important;\n}\n\n.dark-mode .text-gray-700,\n.dark-mode .text-gray-600 {\n  color: #e5e7eb !important;\n}\n\n.dark-mode .text-gray-500 {\n  color: #9ca3af !important;\n}\n\n.dark-mode .bg-gray-50,\n.dark-mode .bg-gray-100 {\n  background-color: #2e2e2e !important;\n}\n\n.dark-mode .bg-indigo-50 {\n  background-color: var(--btn-bg-primary) !important;\n  border-color: var(--secondary-text-color) !important;\n}\n\n.dark-mode .border-gray-200,\n.dark-mode .border-gray-300 {\n  border-color: #3a3a3a !important;\n}\n\n/* ── Form Toggle Switch ── */\n.form-toggle-track {\n  width: 44px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  border-radius: 9999px;\n  padding: 4px;\n  cursor: pointer;\n  transition: background-color 0.3s ease, border-color 0.3s ease;\n  background-color: #d1d5db;\n}\n\n.form-toggle-track.active {\n  background-color: #1a1a1a;\n}\n\n.form-toggle-thumb {\n  background-color: #ffffff;\n  width: 16px;\n  height: 16px;\n  border-radius: 9999px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);\n  transform: translateX(0);\n  transition: transform 0.3s ease, background-color 0.3s ease;\n}\n\n.form-toggle-track.active .form-toggle-thumb {\n  transform: translateX(20px);\n}\n\n/* ── Dark Mode Toggle Support ── */\n.dark-mode .form-toggle-track {\n  background-color: #3f3f46;\n}\n\n.dark-mode .form-toggle-track.active {\n  background-color: #ffffff;\n}\n\n.dark-mode .form-toggle-thumb {\n  background-color: #d4d4d8;\n}\n\n.dark-mode .form-toggle-track.active .form-toggle-thumb {\n  background-color: #18181b;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
